<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius frame-accounts heig-frame-equipment-group userTable">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-default-table :settings="tableConfig"
                        :tbody-tr-class="rowClass"
                        :table-items="tableItems"
                        @load-items="getTableData"
                        @delete-items="deleteItems"
                        @new-item="redirectCreate"
                        @row-click="redirectCreate"
                        @import-items="importUser"
                        @export="exportItems"
                        :show-grid="showGrid"
                        :safetyAllowRoles="fm_allow_roles"
                        ref="gofixTable">
                        <template slot="gofix_table:actions" slot-scope="row" v-if="isAllowDelete(row.item)">
                            <b-form-checkbox disabled></b-form-checkbox>
                        </template>
                        <template slot="gofix_table:role" slot-scope="row">
                            <template v-for="(role, index) in row.item.roles">{{role.name}}<span v-if="index != Object.keys(row.item.roles).length - 1">, </span> </template>
                        </template>
                        <template slot="gofix_table:active" slot-scope="row">
                            {{ (row.item.active == true) ? 'Off' : 'On' }}
                        </template>
                        <template slot="gofix_table:phone" slot-scope="row">
                            {{row.item.address.length ? row.item.address[0].primary_phone : "N/A"}}
                        </template>
                        <template slot="gofix_table:name_organization" slot-scope="row">
                            {{row.item.organization ? row.item.organization.name : "--"}}
                        </template>
                        <template slot="gofix_table:created_at" slot-scope="row">
                            {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:updated_at" slot-scope="row">
                            {{row.item.updated_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:last_login" slot-scope="row">
                            {{row.item.last_login  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:microsoft2fa_enable" slot-scope="row">
                            {{ (row.item.microsoft2fa_enable == true) ? 'On' : 'Off' }}
                        </template>
                        <template slot="gofix_table:show-mold" slot-scope="{gridData, tableSelected, actionStatus}" >
                            <div class="pl-15 pr-15">
                                <b-row v-if="actionStatus.showFilter">
                                    <b-col md="1">
                                        <gofix-form-input label="ID" v-model="pages.filter.id.value" @change="searchUser"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Name" v-model="pages.filter.name.value" @change="searchUser"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Email" v-model="pages.filter.email.value" @change="searchUser"></gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-input label="Mobile" v-model="pages.filter.address_primary_phone.value" @change="searchUser"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-20 rowOrg">
                                    <b-col :key="index" md="4" v-for="(item, index) in gridData">
                                        <div class="boxOrg min-height-150" :class="{'bg-gray-e9e': !item.is_safety}">
                                            <div class="title d-flex align-items-baseline">
                                                <div class="custom-control custom-checkbox-grid custom-control-inline ml-0" v-if="item.is_safety">
                                                    <input type="checkbox" :value="item.id" v-model="tableSelected.selected" class="custom-control-input" :id="'customInChk'+item.id">
                                                    <label class="custom-control-label" :for="'customInChk'+item.id"></label>
                                                </div>
                                                <strong class="mr-3 ml-2">{{item.id}}</strong>
                                                <div class="d-table-cell">
                                                    <strong>{{item.name}}</strong>
                                                </div>
                                            </div>
                                            <div class="content" @click.stop="redirectCreate(item)">
                                                <div>
                                                    <label>Company ID</label> {{item.organization?item.organization.name:'--'}}
                                                </div>
                                                <b-row>
                                                    <b-col md="7">
                                                        <label>Email</label> {{ (item.email.length > 0) ? item.email : '--' }}
                                                    </b-col>
                                                    <b-col md="5" class="pl-0">
                                                        <label class="min-width-45">Status</label> {{ (item.active == true) ? 'Active' : '--' }}
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col md="7">
                                                        <label>Mobile</label> {{ (item.address.length > 0) ? item.address[0].primary_phone : '--' }}
                                                    </b-col>
                                                    <b-col md="5" class="pl-0">
                                                        <label class="min-width-45">Role</label>
                                                        <template v-for="(role, index) in item.roles">{{role.name}}<span v-if="index != Object.keys(item.roles).length - 1">, </span> </template>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </template>
                        <template slot="gofix_table:after-control-left">
                            <li class="control-item showGrid" >
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': showGrid}" @click="toggleList()" title="Grid View" v-b-tooltip.hover><i class="fa fa-th"></i></a>
                            </li>

                            <li class="control-item showGrid" >
                                <a class="control-item-link cursor-pointer showGrid" v-bind:class="{'active': !showGrid}" @click="toggleList()" title="Table view" v-b-tooltip.hover><i class="fa fa-th-list"></i></a>
                            </li>
                        </template>
                        <template slot="gofix_table:before-control-right">
                            <div class="control">
                                <ul class="list-inline">
                                    <li @click="filterListUser('all-safety')" v-bind:class="{'active': pages.filter.type_user == 'all-safety' }" >All Users</li>
                                    <li @click="filterListUser('fm-officer')" v-bind:class="{'active': pages.filter.type_user == 'fm-officer' }" >FM Users</li>
                                    <li @click="filterListUser('supplier')" v-bind:class="{'active': pages.filter.type_user == 'supplier' }" >Supplier Users</li>
                                </ul>
                            </div>
                        </template>
                    </gofix-default-table>
                </b-col>
            </b-row>
        </div>

        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Create User" hide-footer :centered="true" ref="modal-Create">
            <b-form class="pb-20" v-bind:class="{'run-loading':Loadings.create}">
                <gofix-form-dropdown class="gofixInputNoMinWidth" vLabel="text" :reduce="option => option.value" :clearable="false" required label="User Type" v-model="modals.create.type" :options="modals.create.options">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="addItem" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { validationMixin } from 'vuelidate'
    import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'users',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['safety_user']));
            return {
                tableConfig:{
                    name: 'account-users',
                    controls:{
                        create: this.$checkRole(this.$accessModule.safety_app_users, 'create'),
                        delete: this.$checkRole(this.$accessModule.safety_app_users, 'delete'),
                        tableImport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                    dataSelect: {
                        gofix_projects: {
                            value: [],
                            value_field: 'reference_value_text',
                            text_field: 'reference_value_text'
                        }
                    },
                    nameComponent: "safety-user",
                },
                tableItems:[],
                showGrid: false,
                group_tags : "Client",
                isAction: false,
                organizations: [],
                show : 'grid',
                pages: {
                    isCMS: '1',
                    page:1,
                    totalPage : 0,
                    limit:25,
                    filter: JSON.parse(JSON.stringify(filters['safety_user']))
                },
                modals: {
                    delete: {
                        open: false,
                        loading: false,
                        loading_no: false,
                        ids: []
                    },
                    create: {
                        type: null,
                        options: [
                            {
                                value: 'supplier',
                                text: 'Supplier'
                            },
                            {
                                value: 'fm-officer',
                                text: 'FM'
                            },
                        ]
                    }
                },
                fm_allow_roles: []
            }
        },
        mixins: [validationMixin],
        validations: {
            User: {
                name: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                password: {
                    minLength: minLength(8)
                },
                repassword: {
                    sameAsPassword: sameAs("password")
                },
                organization : {
                    required
                }
            }
        },
        created() {
            this.getPreferredGofixProjects();
            this.getFMAllowRoles();
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                Items: 'v2UserController/ListingUser',
                Loadings: 'v2UserController/Loadings',
                Organizations: 'OrganizationController/Organizations',
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            "pages.filter.id.value": function(val){
                this.$refs.gofixTable.tableRequest.filter.id.value = val;
            },
            "pages.filter.name.value": function(val){
                this.$refs.gofixTable.tableRequest.filter.name.value = val;
            },
            "pages.filter.email.value": function(val){
                this.$refs.gofixTable.tableRequest.filter.email.value = val;
            },
            "pages.filter.address_primary_phone.value": function(val){
                this.$refs.gofixTable.tableRequest.filter.address_primary_phone.value = val;
            },
        },
        methods: {
            rowClass(item) {
                if(item) {
                    const flag = this.isAllowDelete(item)
                    if (flag) {
                        return 'bg-gray-e9e';
                    }
                }
                return null;
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.type_user = this.pages.filter.type_user;
                await this.$store.dispatch("v2UserController/getListUser", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of users", "danger");
                        reject();
                    })

            },
            toggleList(){
                this.showGrid = !this.showGrid ;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                resolve('');
                this.modals.delete.ids     = ids;
                this.reqDeleteItems(false);
            },
            reqDeleteItems(is_permanently_deleted = false) {
                if(is_permanently_deleted) this.modals.delete.loading = true;
                else this.modals.delete.loading_no = true;
                this.$store.dispatch("v2UserController/deleteUser", {
                    ids: this.modals.delete.ids,
                    is_permanently_deleted: is_permanently_deleted
                }).then(response => {
                    this.modals.delete.open    = false;
                    this.modals.delete.loading = false;
                    this.modals.delete.loading_no = false;
                    this.$alertNotification(this.$notificationV2('deleting', 'user'));
                    this.searchUser();
                })
                .catch(err =>{
                    console.log(err);
                    this.modals.delete.loading = false;
                    this.modals.delete.loading_no = false;
                    console.error("Got nothing from server. Prompt user to check internet connection and try again")
                });
            },
            redirectCreate(item) {
                if(item){
                    let type_user = this.pages.filter.type_user
                    if(this.pages.filter.type_user == 'all-safety') {
                        if(item.is_fm_company) type_user = 'fm-officer'
                        if(item.is_supplier) type_user = 'supplier'
                    }
                    return this.$router.push(`${this.$route.path}/${type_user}/${item.id}`);
                }
                if(this.pages.filter.type_user == 'all-safety') {
                    this.modals.create.type = null
                    this.$refs['modal-Create'].show()
                    return
                }
                return this.$router.push(`${this.$route.path}/${this.pages.filter.type_user}/add`);
            },
            addItem() {
                if(!this.modals.create.type) this.$alertNotification("Please select a user type.", "danger");
                this.$refs['modal-Create'].hide()
                this.$router.push(`${this.$route.path}/${this.modals.create.type}/add`);
            },
            async searchUser(){
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            filterListUser(type){
                if(this.$refs.gofixTable.tableRequest.filter.type_user != type) {
                    this.$refs.gofixTable.tableRequest.filter.type_user = type;
                    this.pages.filter.type_user = type;
                    this.$refs.gofixTable.reloadTableItems();
                }
            },
            /*--- Export File ---*/
            exportItems(tableRequest) {
                this.$store.dispatch( 'v2UserController/exportItems', tableRequest)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Users.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
            async importUser(callback) {
                const {file, resolve, reject} = await callback();
                await this.$store.dispatch(`v2UserController/import`, {
                fileImport: file
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'user');
                    let result = response.data.data;
                    if (result.data && result.data.count && result.data.count.failed) {
                      variant = 'danger';
                      msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
            getPreferredGofixProjects(){
                let filter = {reference_type: "GOfix Project"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.tableConfig.dataSelect.gofix_projects.value = response.items;
                        this.$refs['gofixTable'].updateDataSelect();
                    })
            },
            getFMAllowRoles(){
                let filter = {reference_type: "Safety Roles"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        if(response.items && response.items.length && response.items[0].reference_value_text) {
                            this.fm_allow_roles = response.items[0].reference_value_text.split(", ");
                        }
                        
                    })
            },
            isAllowDelete(item) {
                if(!item || !item.is_safety) return true;
                if(item.roles && item.roles.length) {
                    const hasNotInSafetyRole = item.roles.some(role => !this.fm_allow_roles.includes(role.name));
                    if(hasNotInSafetyRole) return true;
                }
                return false
            },
        }
    }
</script>
